import { useMemo } from 'react';

import SidebarComponents from './SidebarComponents';
import UWEFormComponent from './UWEFormComponent';
import { UWEFormContextProvider } from '../context/UWEFormContext';
import Jnx from '../util/jnx';
import { useLingui } from '@lingui/react/macro';
import { resolveFormTitle } from 'src/util/i18nTree';

function UWEEntityUWEFormComponent({
  slug,
  form,
  currentEntity,
  dataRemarks,
  loadingDataRemarks,
  onSubmit,
  hideSideTabs,
  wfAccessToken,
  setCurrentEntity,
  overrideOnSubmit,
  resolvedFormVersions,
}) {
  const { i18n } = useLingui();

  const formTitle = useMemo(() => {
    if (form.uiSchema?.['titleExpr']) {
      const jnx = new Jnx(form.uiSchema['titleExpr']);
      return jnx.eval({}, '', { formObject: currentEntity, title: form?.title, locale: i18n.locale });
    }
    return resolveFormTitle(form, i18n.locale);
  }, [form, currentEntity, i18n.locale]);

  // Same rule UWEEntityFormComponent applies to the form itself: an explicit options.readonly wins,
  // otherwise a form authored with no submit buttons cannot be edited.
  const submitButtons = form?.options?.submitButtons;
  const readOnly = form?.options?.readonly ?? (submitButtons != null && Object.keys(submitButtons).length === 0);

  return (
    <UWEFormContextProvider
      initialDataRemarks={dataRemarks}
      loadingDataRemarks={loadingDataRemarks}
      form={form}
      currentEntity={currentEntity}
      wfAccessToken={wfAccessToken}
      setCurrentEntity={setCurrentEntity}
      resolvedFormVersions={resolvedFormVersions}
    >
      <SidebarComponents
        formContainerClassName={form?.uiSchema?.[':classNames'] || ''}
        currentEntity={currentEntity}
        title={formTitle}
        onComponents={form?.sidebarComponents}
        hideSideTabs={hideSideTabs}
        readOnly={readOnly}
        formSchema={form?.schema}
        formUiSchema={form?.uiSchema}
        wfAccessToken={wfAccessToken}
      >
        <UWEFormComponent
          currentEntity={currentEntity}
          form={form}
          slug={slug}
          onSubmit={onSubmit}
          wfAccessToken={wfAccessToken}
          overrideOnSubmit={overrideOnSubmit}
        />
      </SidebarComponents>
    </UWEFormContextProvider>
  );
}

export default UWEEntityUWEFormComponent;
